import type { ThemeColors, ThemeTypes } from '@/types/themeTypes/ThemeType';
import { getThemeColors } from '@/config/configHelpers';

const colors: ThemeColors = getThemeColors('light');

const THEME: ThemeTypes = {
    name: 'THEME',
    dark: false,
    variables: {
        'border-color': '#e5eaef',
        'border-opacity': 0.3
    },
    colors: {
        primary: colors.primary,
        secondary: colors.secondary,
        info: colors.info,
        success: colors.success,
        warning: colors.warning,
        error: colors.error,
        errorSecondary: colors.errorSecondary,
        indigo: colors.indigo,
        lightprimary: colors.lightprimary,
        lightinfo: colors.lightinfo,
        lightsecondary: colors.lightsecondary,
        lightsuccess: colors.lightsuccess,
        lighterror: colors.lighterror,
        lightwarning: colors.lightwarning,
        lightindigo: colors.lightindigo,
        textPrimary: colors.textPrimary,
        textSecondary: colors.textSecondary,
        borderColor: colors.borderColor,
        inputBorder: colors.inputBorder,
        containerBg: colors.containerBg,
        background: colors.background,
        hoverColor: colors.hoverColor,
        surface: colors.surface,
        grey100: colors.grey100,
        grey200: colors.grey200,
        darkbg: colors.darkbg,
        bglight: colors.bglight, // Fondo claro para contrastes
        bgdark: colors.bgdark, // Fondo oscuro para sombras
        blueBin: colors.blueBin, // Azul más oscuro para contraste en bin
        greenProject: colors.greenProject, // Verde más estándar para "Pylc"
        greenNewProject: colors.greenNewProject, // Verde más oscuro para nuevo
        greenRenovationProject: colors.greenRenovationProject, // Verde pastel para renovación
        orangeProject: colors.orangeProject, // Naranja brillante
        yellowProject: colors.yellowProject, // Amarillo más vibrante
        pinkSecondaryProject: colors.pinkSecondaryProject, // Rosa vibrante
        purpleComercialProject: colors.purpleComercialProject // Morado comercial vibrante
    }
};

export { THEME };
